function initializeSwiper() {
  const sectionElms = document.querySelectorAll(".section-about-approach");
  sectionElms.forEach(function (sectionElm) {
    const elId = sectionElm.id;

    const swiperElm = sectionElm.querySelector(".img-banner-slider");
    if (!swiperElm) {
      return;
    }

    const paginationElm = sectionElm.querySelector(".swiper-pagination");

    new Swiper(swiperElm, {
      loop: true,
      preloadImages: true,
      lazy: true,
      pagination: {
        el: paginationElm,
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
      on: {
        slideChange: function (s) {
          const tt = sectionElm.querySelectorAll(".text");
          console.log("tt:", tt);
          tt.forEach(function (el) {
            el.classList.add("hide-m");
          });
          if (s.activeIndex === tt.length + 1) {
            const textElement1 = sectionElm.querySelector("#text1");
            if (textElement1) {
              textElement1.classList.remove("hide-m");
            }
          } else if (s.activeIndex === 0) {
            const textElementLast = sectionElm.querySelector(
              "#text" + tt.length
            );
            if (textElementLast) {
              textElementLast.classList.remove("hide-m");
            }
          } else {
            const textElement = sectionElm.querySelector(
              "#text" + s.activeIndex
            );
            if (textElement) {
              textElement.classList.remove("hide-m");
            }
          }
        },
      },
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initializeSwiper();
});
